module.exports = __webpack_public_path__ + "static/img/arrow3.75a20d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/arrow3.png
// module id = 6CCu
// module chunks = 36